import styled from "styled-components";

export const Photo = styled.img`
  border-radius: 10px;
  width: 100%;
  margin-bottom: 15px;
`;

export const Information = styled.h4`
  font-size: 16px;
  width: 50%;
  margin: 30px 0;
  text-align: center;
  @media only screen and (max-width: 600px) {
    width: 75%;
  }
`;

export const ViewLogin = styled.div`
  max-width: 350px;
  padding: 60px 0;
  border-radius: 10px;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #d7f0db;
  display: flex;
  justify-content: center;

  input {
    width: 90%;
    margin-top: 10px;
  }

  button {
    width: 90%;
    border-radius: 25px;
    margin-top: 20px;
  }
`;
